import { ReactNode } from 'react';

import CopyButton from '@/components/atoms/CopyButton/CopyButton';
import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';

type CopyInputProps = {
  value: string;
  hasTooltip?: boolean;
  tooltipSide?: 'left' | 'top' | 'right' | 'bottom';
  tooltipContent?: ReactNode;
};

export const CopyInput = ({
  value,
  hasTooltip = true,
  tooltipSide,
  tooltipContent,
}: CopyInputProps) => {
  const input = (
    <InputGroup size="sm" className="shadow-none">
      <InputGroupInput readOnly value={value} className="truncate" />
      <InputGroupAddon align="inline-end" className="pr-0">
        <CopyButton data={value} size="sm" iconSize={14} />
      </InputGroupAddon>
    </InputGroup>
  );

  if (!hasTooltip) {
    return input;
  }

  return (
    <InfoTooltip
      content={tooltipContent ?? <span className="break-all">{value}</span>}
      size="large"
      side={tooltipSide}
    >
      {input}
    </InfoTooltip>
  );
};
